import { createReducer } from '@reduxjs/toolkit';

import { BankType } from '../../pages/exchange/mock';
import {
  getExchanges,
  setExchange,
  setExchangeLoading,
} from '../actions/exchange';

const ExchangeBanks = {
  sigma: {
    name: 'ЦФА Сигма',
    rate: {
      sber: 1.0,
      alfa: 1.0,
      gazprom: 1.0,
      tinkoff: 1.0,
      sigma: 1.0,
    },
    balance: 3443534543,
    change: -0.6,
  },
  sber: {
    name: 'ЦФА Сбер',
    rate: {
      sigma: 1.0,
      alfa: 1.0,
      gazprom: 1.0,
      tinkoff: 1.0,
      sber: 1.0,
    },
    balance: 102393,
    change: 0.3,
  },
  alfa: {
    name: 'ЦФА Альфа',
    rate: {
      sigma: 1.0,
      sber: 1.0,
      gazprom: 1.0,
      tinkoff: 1.0,
      alfa: 1.0,
    },
    balance: 67868,
    change: 0,
  },
  gazprom: {
    name: 'ЦФА Газпром',
    rate: {
      sigma: 1.0,
      sber: 1.0,
      alfa: 1.0,
      tinkoff: 1.0,
      gazprom: 1.0,
    },
    balance: 12323421,
    change: -0.4,
  },
  tinkoff: {
    name: 'ЦФА Тинькофф',
    rate: {
      sigma: 1.0,
      sber: 1.0,
      alfa: 1.0,
      gazprom: 1.0,
      tinkoff: 1.0,
    },
    balance: 98989889,
    change: -0.6,
  },
};

const initialState: any = {
  loading: {
    exchange: false,
  },
  exchanges: [],
  exchangeBanks: ExchangeBanks,
  exchangeHistory: [],
};

const exchangeReducer = createReducer(initialState, (builder) => {
  builder.addCase(setExchangeLoading, (state, action) => {
    state.loading[action.payload.type] = action.payload.value;
  });

  builder.addCase(setExchange.fulfilled, (state, action) => {
    state.exchangeBanks[action.payload?.buyBank as BankType].balance += Number(
      action.payload?.buy
    );
    state.exchangeBanks[action.payload?.saleBank as BankType].balance -=
      Number(action.payload?.sale) + Number(action.payload?.sale) * 0.2;
    state.exchangeHistory.push({
      ...action.payload,
      commission: (Number(action.payload?.sale) * 0.2).toFixed(2),
    });
  });

  builder.addCase(getExchanges.fulfilled, (state, action) => {
    state.exchanges = action.payload;
  });
});

export default exchangeReducer;
